// src/stores/UploadStore.ts
import { makeAutoObservable } from 'mobx';

export class UiStore {
  selectedModuleId: number | null = null;
  selectedLineId: number | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setSelectedModuleId(id: number | null) {
    this.selectedModuleId = this.selectedModuleId === id ? null : id;
    // Снимаем выделение линии при выделении модуля
    
  }

  setSelectedLineId(id: number | null) {
    this.selectedLineId = this.selectedLineId === id ? null : id;
    // Снимаем выделение модуля при выделении линии
    if (this.selectedLineId !== null) {
      this.selectedModuleId = null;
    }
  }

}

export const uiStore = new UiStore();
